import { useCustomerDetailPageContext } from '../datacontroller/CustomerDetailPageContext';
import Divider from '@/common/view/Divider';
import { CustomerInfoRow } from './CustomerInfoRow';

const GENDER_LABELS = {
  M: '남성',
  F: '여성',
} as const;

const getGenderLabel = (gender?: string) => {
  if (!gender) return undefined;
  return GENDER_LABELS[gender as keyof typeof GENDER_LABELS] ?? gender;
};

const getAgeLabel = (age?: number | string) => {
  if (age == null) return undefined;
  const ageNumber = typeof age === 'string' ? Number(age) : age;
  return !isNaN(ageNumber) ? `만 ${ageNumber}세` : age;
};

export const CustomerLeftInfoView = () => {
  const { customerDetail } = useCustomerDetailPageContext();

  return (
    <div className="rounded-lg bg-typeb-grayWhite p-5 flex-1 flex flex-col gap-3">
      <CustomerInfoRow label="이름" value={customerDetail?.customer_name} />
      <CustomerInfoRow label="연락처" value={customerDetail?.hp_no} />
      <CustomerInfoRow label="성별" value={getGenderLabel(customerDetail?.gender)} />
      <CustomerInfoRow label="연령" value={getAgeLabel(customerDetail?.age)} />
      <CustomerInfoRow label="생일" value={customerDetail?.birthday} />
      <CustomerInfoRow label="회원 그룹" value={customerDetail?.group_name} />
      <CustomerInfoRow
        label="온라인 적립금"
        value={customerDetail?.point != null ? `${customerDetail.point.toLocaleString()} Point` : undefined}
      />
      <Divider size="small" />
      <CustomerInfoRow label="주소" value={customerDetail?.delivery_address} />
      <CustomerInfoRow label="피부타입" value={customerDetail?.skin_type} />
      <CustomerInfoRow label="온라인 등급" value={customerDetail?.grade_name} />
      <CustomerInfoRow
        label="승급 잔여금액"
        value={
          customerDetail?.grade_up_remaining_amount != null
            ? `${customerDetail.grade_up_remaining_amount.toLocaleString()}원`
            : undefined
        }
      />
    </div>
  );
};
